import React, { useState } from "react";
import { KeyRound } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const ChangePasswordScreen = () => {
  const { user, setUser, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const mismatch = f.confirm && f.next !== f.confirm;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      localStorage.setItem("bides_token", data.token);
      setUser({ ...user, must_change_password: false });
      toast.success("Password updated");
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  const field = (k, label, tid) => (
    <div><Label className="overline">{label}</Label>
      <Input data-testid={tid} type="password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5 bg-white" /></div>
  );
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="change-password-screen">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-border rounded-md p-7 space-y-4">
        <div className="h-11 w-11 rounded-md bg-[#18181A] text-white flex items-center justify-center"><KeyRound className="h-5 w-5" /></div>
        <div>
          <h1 className="font-head text-2xl font-extrabold tracking-tight">Choose a new password</h1>
          <p className="text-sm text-muted-foreground mt-1">Hi {user.name}, you signed in with a temporary password. Set your own to continue.</p>
        </div>
        {field("current", "Temporary password", "cp-current-input")}
        {field("next", "New password (min 8 characters)", "cp-new-input")}
        {field("confirm", "Confirm new password", "cp-confirm-input")}
        {mismatch && <p data-testid="cp-mismatch" className="text-xs text-[#9E382A]">Passwords don't match.</p>}
        <Button type="submit" data-testid="cp-submit" className="w-full" disabled={busy || !f.current || f.next.length < 8 || f.next !== f.confirm}>
          {busy ? "Saving…" : "Save and continue"}
        </Button>
        <button type="button" data-testid="cp-logout" onClick={logout} className="block w-full text-center text-xs text-muted-foreground hover:text-foreground">Sign out</button>
      </form>
    </div>
  );
};
